import React from "react";
import { useTranslation } from "react-i18next";

// reactstrap components
import { Container, Row, Col } from "reactstrap";
import CommonNavbar from "@/components/Navbars/CommonNavbar";

import "./HomePage.scss";
import PickService from "./PickService/PickService";
import PickServiceMobile from "./PickService/Mobile/PickServiceMobile";

const HomePage = () => {
  // navbar collapses states and functions
  const [navbarOpen1, setNavbarOpen1] = React.useState(false);
  const [navbarOpen2, setNavbarOpen2] = React.useState(false);
  const [navbarOpen3, setNavbarOpen3] = React.useState(false);

  const { t } = useTranslation();

  return (
    <>
      <CommonNavbar />
      <div className="wrapper">
        <div className="cd-section" id="headers">
          {navbarOpen1 || navbarOpen2 || navbarOpen3 ? (
            <div
              id="bodyClick"
              onClick={() => {
                document.documentElement.classList.toggle("nav-open");
                setNavbarOpen1(false);
                setNavbarOpen2(false);
                setNavbarOpen3(false);
              }}
            />
          ) : null}
          <div className="header-2 home-page">
            <div className="page-header header-filter">
              <div
                className="page-header-image"
                style={{
                  backgroundImage:
                    "url(" + require("assets/img/person-writing.jpg") + ")",
                  position: "fixed"
                }}
              ></div>
              <Container className="home-content">
                <Row>
                  <Col className="ml-auto mr-auto text-center" md="8">
                    <h1 className="title">{t("pages.homePage.title")}</h1>
                    <h5 className="description">
                      {t("pages.homePage.description1")}
                      <br />
                      {t("pages.homePage.description2")}
                    </h5>
                  </Col>
                  {/* <Tabs /> */}
                  <PickServiceMobile />
                  <PickService />
                </Row>
              </Container>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default HomePage;
